module.exports = [["atMyHouse","Bei mir"],["atYourHouse","Beim Paten"]]


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/RequestPlace.json
// module id = 546
// module chunks = 0